var Header = {};

//--------------
// Variables
//--------------
Header.$toggleMenu = $('.js-toggle-menu');
Header.$menu = $('.js-menu');


//--------------
// Functions
//--------------

/**
 * ?
 * @return {void}
 */
Header.menuColWidth = function() {
	var menuColWidth = $('.js-menu-col').outerWidth();
	$('.js-menu-col-inner').css({left: menuColWidth/2});
}

/**
 * Open menu
 * @return {void}
 */
Header.openMenu = function() {
	console.log('Open menu');
	Header.$toggleMenu.addClass('is-active');
	Header.$menu.addClass('is-active');
}

/**
 * Close menu
 * @return {void}
 */
Header.closeMenu = function() {
	console.log('Close menu');
	Header.$toggleMenu.removeClass('is-active');
	Header.$menu.removeClass('is-active');
}

/**
 * Toggle menu
 * @return {void}
 */
Header.toggleMenu = function() {
	console.log(Header.$menu.hasClass('is-active'));
	if(Header.$menu.hasClass('is-active')) {
		Header.closeMenu();
	} else {
		Header.openMenu();
	}
}

/**
 * Init header scripts
 * @return {void}
 */
Header.init = function(){
	//-- Open/Close Menu
	Header.$toggleMenu.on('click', Header.toggleMenu);

	//-- ?
	Header.menuColWidth();

	//-- ?
	$(window).resize(function() {
		Header.menuColWidth();
	});
}

//--------------
// Execution
//--------------

Header.init();

module.exports = Header;